import React, { useContext, useEffect, useState } from "react";
import { CsrfContext } from "../context/CsrfContext";
import IncorrectId from "./IncorrectId";
import { FetchPost } from "../utils/fetch";
import { LoadState } from "../utils/LoadState";

interface CheckUserIdStepProps {
    goNextStep: () => void
    goBack: () => void
    userId: string
}

const CheckUserIdStep: React.FC<CheckUserIdStepProps> = ({ goNextStep, goBack, userId }) => {
    const [state, setState] = useState<LoadState>(LoadState.Loading);
    const csrfContext = useContext(CsrfContext);

    useEffect(() => {
        FetchPost(csrfContext.csrfToken, "check-user-id",
            {
                'userId': userId
            },
            (json: any) => setState(json.ok ? LoadState.Success : LoadState.Fail),
            (err: any) => setState(LoadState.Fail)
        );
    }, [csrfContext.csrfToken, userId]);

    switch (state) {
        case LoadState.Loading:
        default:
            return <div>Проверка учетной записи {userId}...</div>;
        case LoadState.Success:
            return <div><button onClick={() => goNextStep()}> Активировать учетную запись {userId} </button></div>;
        case LoadState.Fail:
            return <IncorrectId goBack={goBack} userId={userId} />;
    }
}

export default CheckUserIdStep;